import './style.scss'
import * as React from 'react'
import * as _ from 'lodash'

import {Popover, Checkbox as AntDCheckbox, Row, Col} from 'antd'
import Checkbox from '../../../../core/Checkbox'
import {GlobalFilterButton} from '../GlobalFilterButton'
import { AnalyticsGlobalFilters, ChannelFilter, DeviceFilter} from '../../../constants'
const CheckboxGroup = AntDCheckbox.Group
const AntPopover : any = Popover

export class GlobalFilterSelector extends React.Component<GlobalFilterSelector.Props, any> {
  constructor(){
    super()
    this.state = {globalFilters: initialFilterState }
  }

  componentWillMount(){
    this.setState({globalFilters: this.props.globalFilters})
  }

  componentWillReceiveProps(nextProps: GlobalFilterSelector.Props) {
    this.setState({globalFilters: nextProps.globalFilters})
  }

  visibilityChange = (visible:boolean) => {
    //only update redux state after filters have been changed while closing the popover
    if(!visible && (!_.isEqual(_.sortBy(this.props.globalFilters.device), _.sortBy(this.state.globalFilters.device))||
    !_.isEqual(_.sortBy(this.props.globalFilters.channel), _.sortBy(this.state.globalFilters.channel)))){
      this.props.setGlobalFilters(this.state.globalFilters)
    }
  }

  handleFilterSelection = (filterGroup: string, filters: DeviceFilter[]|ChannelFilter[]) => {
      this.setState(prevState => ({globalFilters: {...prevState.globalFilters, [filterGroup]: filters}}))
  }

  render(){
    return(
      <AntPopover overlayClassName="global-filter-popover" onVisibleChange={this.visibilityChange} content={
        <FilterPopover isOneApp={this.props.isOneApp} globalFilters={this.state.globalFilters} handleFilterSelection={this.handleFilterSelection}/>
      } trigger='click'>
        <GlobalFilterButton globalFilters={this.props.globalFilters}/>
      </AntPopover>
    )
  }
}

export namespace GlobalFilterSelector {
  export interface Props {
    globalFilters?: AnalyticsGlobalFilters
    setGlobalFilters?: (filters: AnalyticsGlobalFilters) => void
    history?: any
    isOneApp?: boolean
  }

  export interface State {
    globalFilters:AnalyticsGlobalFilters
  }

  export interface DisabledFilters{
    device : string
    channel : string
  }
}


const initialFilterState :AnalyticsGlobalFilters= {
  device: [],
  channel: []
}

const initialDisabledState = {
  device : '',
  channel: ''
}

export namespace GlobalFilterPopover {
  export interface Props {
    globalFilters:AnalyticsGlobalFilters
    handleFilterSelection?:(filterGroup: string, filters: string[]) => void
    isOneApp?: boolean
  }
}

const FilterPopover = (props:GlobalFilterPopover.Props) : any => {
  const getChannelFilters = () =>  _.uniq(props.globalFilters.channel)
  const getDeviceFilters = () =>  _.uniq(props.globalFilters.device)

  const disableCheckbox = (filterGroup: string, value:string) => {
    let disabled = false
    let filters
    switch(filterGroup){
      case 'device':
        filters = getDeviceFilters()
        if(filters.length == 1 && filters[0] == value){
          disabled = true
        }
        break
      case 'channel':
        filters = getChannelFilters()
        if(filters.length == 1 && filters[0] == value){
          disabled = true
        }
        break
    }
    return disabled
  }

  return(
    <div className='global-filter-popover' id='global-filter-popover'>
      <span className='global-filter-header'>Channel</span>
      <CheckboxGroup value={getChannelFilters()} onChange={(values : ChannelFilter[])=>props.handleFilterSelection('channel', values)}>
        <div>
          <Checkbox className='global-filter-checkbox' value={'hosted'} disabled={disableCheckbox('channel', 'hosted')} dataAutomationID={'global-filter-hosted'}>Hosted</Checkbox>
          {!props.isOneApp ?
              (<Checkbox className='global-filter-checkbox' value={'distribution'} disabled={disableCheckbox('channel', 'distribution')}
                         dataAutomationID={'global-filter-distribution'}>Flipp Network</Checkbox>)
              : (<Checkbox className='global-filter-checkbox' disabled dataAutomationID={'global-filter-distribution'}>Flipp Network</Checkbox>)
          }
        </div>
      </CheckboxGroup>
      <br/>
      <span className='global-filter-header'>Device</span>
      <CheckboxGroup value={getDeviceFilters()} onChange={(values : DeviceFilter[])=>props.handleFilterSelection('device', values)}>
        <div>
          <Checkbox className='global-filter-checkbox' value={'mobile'} disabled={disableCheckbox('device', 'mobile')} dataAutomationID={'global-filter-mobile'}>Mobile/Tablet</Checkbox>
          <Checkbox className='global-filter-checkbox' value={'desktop'} disabled={disableCheckbox('device', 'desktop')} dataAutomationID={'global-filter-desktop'}>Desktop</Checkbox>
        </div>
      </CheckboxGroup>
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/common/GlobalFilterSelector/index.tsx